import { Res } from 'core/api';
import * as React from 'react';
import { ComboBox } from './ComboBox';
import * as TagUtils from './TagUtils';

type TagFilterParams<TModel, TOption> = {
	linkTo: (model: TModel) => string[];
	maybeTaggableItems: TOption[];
	onValueChanged: (values: string[]) => void;
	allowedTags: string[] | undefined;
};

export function createTagsFilter<TModel, TOption = any>({
	linkTo,
	maybeTaggableItems,
	onValueChanged,
	allowedTags
}: TagFilterParams<TModel, TOption>): React.ReactNode {

	return TagUtils.showTagFilter(maybeTaggableItems, allowedTags ?? []) && <ComboBox<TModel>
		label={Res.WA.WA_TAGS_FILTER_TAGS_LBL()}
		linkTo={linkTo}
		options={allowedTags?.length ? allowedTags : TagUtils.getDistinctTags(maybeTaggableItems)}
		multiple
		placeholder={Res.WA.WA_TAGS_FILTER_TAGS_PLACEHOLDER()}
		onValueChanged={onValueChanged} />;
}
